import NumberField from "@p-ban/common/src/components/form/NumberField/NumberField"
import useDebounce from "@p-ban/common/src/hooks/useDebounce"

import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./vcutCnt.png"

const Vカット = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { vcutCnt: shouldShow } = getDisplayCondition(values)
  const onUpdateValue = useDebounce(handlers.number)
  const legend = "Vカット"

  return (
    <OneClickField isShow={shouldShow} legend={legend} helpURL={HELP_LINKS.Vカット} src={img}>
      <NumberField
        name={FIELD_NAMES.Vカット}
        value={values.vcutCnt}
        onUpdateValue={onUpdateValue}
        min={0}
        max={99}
        maxDecimalDigits={0}
        step={1}
        suffix="本"
        error={!!errors?.vcutCnt}
        aria-label={legend}
      />
      <OneClickFieldMessages error={errors?.vcutCnt} />
    </OneClickField>
  )
}

export default Vカット
